import React, { useState } from "react";
import { useCallback } from "react";
import { NavLink } from "react-router-dom";
import { NavItem } from "reactstrap";
import config from "../../../../../config/customers";
import {
  HeaderCollapse,
  HeaderLogo,
  HeaderNav,
  HeaderNavbar,
  HeaderNavbarToggler,
  HeaderNavLink,
} from "./components";

const {
  publicPortal: { navbar: navbarConfig },
} = config;

const Navbar = ({setShowModal}) => {
  const renderNavLink = useCallback(({ text, url: to, external, modal }) => {
    const tag = external ? "a" : NavLink;
    const tagProps = external ? { href: to } : { to };
    const target = external ? "_blank" : "";
    const handleClick = (e) => {
      if (modal) {
        e.preventDefault()
        setShowModal(true)
      }
    }

    return (
      <NavItem key={text}>
        <HeaderNavLink {...tagProps} tag={tag} target={target} onClick={(e) => handleClick(e)}>
          {text}
        </HeaderNavLink>
      </NavItem>
    );
  }, [setShowModal]);

  const [isOpen, setIsOpen] = useState(false);
  const toggleNavbar = () => setIsOpen((oldValue) => !oldValue);

  return (
    <nav>
      <HeaderNavbar color="dyna-light" expand="lg" sticky="top">
        <HeaderLogo logo={navbarConfig.logo} link={navbarConfig.href} />
        <HeaderNavbarToggler onClick={toggleNavbar} isOpen={isOpen} />
        <HeaderCollapse isOpen={isOpen} navbar>
          <HeaderNav navbar>{navbarConfig.links.map(renderNavLink)}</HeaderNav>
        </HeaderCollapse>
      </HeaderNavbar>
    </nav>
  );
};

export default Navbar;
